<template>
  <b-modal
    id="files-modal"
    :hide-footer="true"
    size="xl"
    ref="files_modal"
    :title="'Pliki w kategori: '+ category.name "
    modal-class="drag_drop"
    @hidden="onClose"
    @show="onShow"
    :lazy="true"
  >
    <div class="row mb-4">
      <div class="col-md-6">
        <FilesUpload
          :construction_id="construction_id"
          :category="category"
          :dropzoneid="'files-modal'"
          @endupload="this.refreshLightBox"
        />
      </div>
      <div class="col-md-6 text-left text-md-right" v-if="isNotSubcontractor">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          v-show="selected.length > 0"
          @click="selected=[]"
        >
          <i class="fas fa-times"></i>
        </b-button>
        <b-button
          variant="danger"
          :disabled="selected.length === 0 || deleteprocessing"
          @click="remove"
        >
          <b-spinner small class="align-middle" v-if="deleteprocessing"></b-spinner>
          <template v-else>
            <i class="far fa-trash-alt mr-2"></i> Usuń
            <span v-show="selected.length > 0">( {{selected.length}} ) pliki</span>
          </template>
        </b-button>
      </div>
    </div>
    <div class="row">
      <div
        class="col-xl-2 col-lg-3 col-md-6 mb-2 picture"
        v-for="(item, index) in files"
        :key="index"
      >
        <div class="picture-title">
          <span v-if="item.thumb">
            Dodano:
            <i>{{ item.created_at | date }}</i>
          </span>
        </div>
        <div class="picture-wrapper">
          <div
            v-if="isNotSubcontractor"
            :class="{'picture-checkbox':true, 'selected': selected.indexOf(item.id)>-1}"
            @click="toggleChecked(item.id)"
          >
            <i :class="isChecked(item.id)"></i>
          </div>
          <div class="picture-image" @click="showLightbox(item.url)" v-if="item.thumb">
            <img :src="item.thumb" />
          </div>
          <div class="file" v-else>
            <a :href="item.url" target="_blank" :title="item.filename">
              <i :class="fileIcon(item.extension)"></i>
              <div class="file-name">{{item.filename}}</div>
              <div>
                <i class="file-createat">{{ item.created_at | date }}</i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
      <div v-if="files.length === 0" class="empty">
              <i class="empty-state far fa-images"></i>
              <span class="empty-search">Brak Zdjęć</span>
            </div>
  </b-modal>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import FilesUpload from "@/components/files/FilesUpload";
import {formatDateOnly} from "@/services/helpers";

export default {
  name: "FilesModal",
  components: { FilesUpload },
  props: {
    construction_id: { type: Number },
    category: { type: Object },
    files: {
      type: Array
    }
  },
  data() {
    return {
      deleteprocessing: false,
      images: [],
      selected: []
    };
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  computed: {
    ...mapGetters("app", ["availableFileCategory"]),
    ...mapGetters("user", ["isNotSubcontractor"])
  },
  methods: {
    ...mapActions("construction", ["fileRemove"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      this.images = [];
      this.refreshLightBox();
    },
    onClose() {
      this.selected = [];
    },
    remove() {
      if (this.selected.length === 0) return;
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz usunąć zaznaczone plik/pliki ?", {
          title: "Potwierdź usunięcie plik/ów",
          okVariant: "danger",
          okTitle: "TAK",
          cancelTitle: "NIE"
        })
        .then(result => {
          if (result === true) {
            this.deleteprocessing = true;
            this.$Progress.start();
            this.fileRemove({
              filesIds: this.selected,
              categoryId: this.category.id
            }).finally(() => {
              this.selected = [];
              this.deleteprocessing = false;
            });
          }
        });
    },
    refreshLightBox() {
      let images = [];
      this.$_.each(this.files, file => {
        if (file.thumb) {
          images.push({ name: file.url });
        }
      });
      this.$store.commit("lightbox/push", images);
    },
    showLightbox: function(imageName) {
      this.$store.commit("lightbox/show", imageName);
    },
    fileIcon: function(extension) {
      let css = {
        far: true,
        "file-icon": true
      };
      switch (extension) {
        case "doc":
        case "docx":
        case "odt":
          css["fa-file-word"] = true;
          css["text-primary"] = true;
          break;
        case "pdf":
          css["fa-file-pdf"] = true;
          css["text-danger"] = true;
          break;
        case "xlsx":
        case "xls":
        case "ods":
          css["fa-file-excel"] = true;
          css["text-success"] = true;
          break;
        default:
          css["fa-file-alt"] = true;
      }
      return css;
    },
    toggleChecked: function(file_id) {
      let index = this.selected.indexOf(file_id);
      if (index >= 0) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(file_id);
      }
    },
    isChecked: function(file_id) {
      let isChecked = this.selected.indexOf(file_id) >= 0;
      return {
        far: !isChecked,
        fas: isChecked,
        "fa-circle": !isChecked,
        "fa-check-circle": isChecked,
        "text-primary": isChecked
      };
    }
  }
};
</script>
